export const BASE_API = "https://uxcandy.com/~shapoval/test-task-backend/";
